module.exports = __webpack_public_path__ + "img/language.96491a51.svg";